import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {CatalogSearchFilterOptionChangedEvent, CatalogSearchFilterSelectOptions} from '@store/catalog/catalog.types';

@Component({
  selector: 'px-catalog-filter-options',
  host: {
    class: 'flex flex-col'
  },
  template: `
    @for (option of options; track option.value) {
      <mat-checkbox [checked]="option.selected" (change)="onChange($event, option.value)" [class.bg-surface1]="option.selected">
        <span class="text-title-medium lg:text-body-medium">
          {{ option.displayName }}

          @if (option.count) {
            ({{ option.count | format:'NUMBER' }})
          }
        </span>
      </mat-checkbox>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckbox, FormatPipe]
})
export class CatalogFilterOptionsComponent {
  @Input({required: true}) public options: CatalogSearchFilterSelectOptions = [];

  @Output() public readonly selectionChanged: EventEmitter<CatalogSearchFilterOptionChangedEvent> = new EventEmitter();

  public onChange(event: MatCheckboxChange, value: string): void {
    this.selectionChanged.emit({value, selected: event.checked});
  }
}
